<template>
	<v-container
			class="customVContainer fluid container_"
			:style="$_menu_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<template v-if="$_menu_currentUserUid()">
				<v-row class="mt-6">
					<v-col class="center" cols="12">
						<v-img	class="image_"
								:aspect-ratio="1"
								max-height="150px"
								max-width="150px"
								contain
								:src="$_menu_stateUserProfilePictureUrl()"
								@click="openLink({ to: '/profile' })" />
					</v-col>
					<v-col class="center" cols="12">
						<v-btn	small
								text
								to="/profile"
								v-text="$_menu_stateUserFullName()" />
					</v-col>
				</v-row>
			</template>
			<searchbar-list />
			<menu-list />
			<chat-list />
			<setting-list />
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
		<version-info-footer />
	</v-container>
</template>

<script>
	export default {
		name: 'Menu',
		data() {
			return {
				pageName_: 'menu',
				pageType_: 'menu',

				initialized_: false
			}
		},
		computed: {
			// current user
			$_menu_currentUserUid() {
				const self_ = this;
				return () => {
					return self_.getCurrentUser('uid')	
				}
			},
			// state
			$_menu_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_menu_stateUserFullName() {
				const self_ = this;
				return () => {
					return self_.getUserState('fullName')
				}
			},
			$_menu_stateUserProfilePictureUrl() {
				const self_ = this;
				return () => {
					return self_.getUserState('profilePictureUrl')
				}
			},
			// contents / inits
			$_menu_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_menu_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_menu_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_menu_inits(), 'contact')
			},
			// style
			$_menu_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_menu_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_menu_inits(), 'pageContainer')
			},
			$_menu_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_menu_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_menu_setPageState()

			if(self_.$_menu_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_menu_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_menu_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_menu_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_menu_initialize()', error)
				})
			}
		}
	}
</script>

<style scoped>
	@media screen and (max-width:959px) {
		.container_ {
			margin-bottom: 48px !important;
		}
	}
	.image_ {
		border-radius: 75px !important;
	}
</style>
